/*
 * Mobile - Homepage - Trust Badge Optimzation  --  variant: Horizontal Trust Badges
 * Moonshot experiment id: 32232861   status in Moonshot on 2026-08-27: DEPLOYED   started: 2026-03-13
 * Audience: MOBILE   Target: homepage   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_home_m_trust_badges
 */
MGExp.run('home_m_trust_badges', { name: "Mobile - Homepage - Trust Badge Optimzation / Horizontal Trust Badges", platform: 'mobile', target: 'homepage' }, function () {
  !(function () {
    const t = [],
      i = [];
    !(async function (o, e, a, n, l) {
      const s = {
        multi_target_selectors: t,
        page_identifier_selector: ".dc-hero-banner.home-banner-2022",
        exclude_from_timeout: i,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(o, e, a, n, l, s);
    })(
      [
        "#shopify-section-162281316406e1737c",
        "#shopify-section-162281316406e1737c .usp-block",
      ],
      ".msai-multi-horizontal-badges-applied",
      function (t, i) {
        const [o, e] = i,
          a = o.querySelectorAll(".usp-block"),
          n = Array.from(a).filter(function (t) {
            const i = t.querySelector("p.font-bold");
            return !(i ? i.textContent.trim() : "").includes("80%");
          }),
          l = n.length ? n[0] : null,
          s = n.length ? n[n.length - 1] : null;
        (a.forEach(function (t) {
          const i = t.querySelector("p.font-bold"),
            o = i ? i.textContent.trim() : "";
          if (o.includes("80%"))
            return void t.classList.add("msai-multi-hidden-block");
          i &&
            (o.includes("14 Day") && o.includes("Return Policy")
              ? (i.innerHTML = "14 Day<br>Return Policy*")
              : o.includes("Same Day") &&
                o.includes("Shipping") &&
                (i.innerHTML = o.replace("Same Day", "Same<br>Day")));
          const e = t.querySelectorAll("p.fs-14");
          if (e.length) {
            const i = Array.from(e)
                .map(function (t) {
                  return t.textContent.trim();
                })
                .join(" "),
              o = document.createElement("div");
            (o.classList.add("msai-multi-badge-tooltip"),
              t === l
                ? o.classList.add("msai-multi-badge-tooltip-left")
                : t === s && o.classList.add("msai-multi-badge-tooltip-right"),
              (o.textContent = i),
              t.insertAdjacentElement("beforeend", o),
              t.addEventListener("click", function () {
                const t = document.querySelector(
                  "#shopify-section-162281316406e1737c",
                );
                (t &&
                  t
                    .querySelectorAll(".msai-multi-badge-tooltip")
                    .forEach(function (t) {
                      t !== o && t.classList.remove("msai-multi-tooltip-visible");
                    }),
                  o.classList.toggle("msai-multi-tooltip-visible"));
              }));
          }
        }),
          (o._msaiDocClickHandler = function (t) {
            if (!t.target.closest(".usp-block")) {
              const t = document.querySelector(
                "#shopify-section-162281316406e1737c",
              );
              t &&
                t
                  .querySelectorAll(".msai-multi-badge-tooltip")
                  .forEach(function (t) {
                    t.classList.remove("msai-multi-tooltip-visible");
                  });
            }
          }),
          document.addEventListener("click", o._msaiDocClickHandler),
          o.classList.add("msai-multi-horizontal-badges-applied"));
      },
      ".msai-multi-horizontal-badges-applied{margin:40px 0 !important;padding:30px 0 !important;background:#fbf5ee}.msai-multi-horizontal-badges-applied section{padding:15px 0 !important}.msai-multi-horizontal-badges-applied .usp-flex{display:flex !important;flex-direction:row !important;align-items:flex-start !important;justify-content:space-around !important;flex-wrap:nowrap !important;gap:0 !important}.msai-multi-horizontal-badges-applied .usp-divider-line{display:none !important}.msai-multi-horizontal-badges-applied .usp-block{flex:1 !important;text-align:center !important;padding:10px 12px !important;min-width:0 !important;display:flex !important;flex-direction:column !important;align-items:center !important;justify-content:flex-start !important;cursor:pointer !important;position:relative !important}.msai-multi-horizontal-badges-applied .usp-block.msai-multi-hidden-block{display:none !important}.msai-multi-horizontal-badges-applied .usp-block .usp-block-icon{width:68px !important;height:68px !important;background:#fff !important;border-radius:50% !important;display:flex !important;align-items:center !important;justify-content:center !important;margin:0 auto 8px !important}.msai-multi-horizontal-badges-applied .usp-block .usp-block-icon img{width:38px !important;height:38px !important;margin:0 !important}.msai-multi-horizontal-badges-applied .usp-block p.font-bold{font-size:12px !important;margin:0 !important;text-align:center !important}.msai-multi-horizontal-badges-applied .usp-block p.fs-14{display:none !important}.msai-multi-horizontal-badges-applied .usp-block .msai-multi-badge-tooltip{display:none;position:absolute;bottom:calc(100% + 6px);left:50%;transform:translateX(-50%);background:#333;color:#fff;padding:8px 12px;border-radius:6px;font-size:11px;line-height:1.4;white-space:normal;width:170px;text-align:center;z-index:9999;box-shadow:0 2px 8px rgba(0,0,0,0.2);pointer-events:none}.msai-multi-horizontal-badges-applied .usp-block .msai-multi-badge-tooltip.msai-multi-tooltip-visible{display:block}.msai-multi-horizontal-badges-applied .usp-block .msai-multi-badge-tooltip.msai-multi-badge-tooltip-left{left:0;transform:none}.msai-multi-horizontal-badges-applied .usp-block .msai-multi-badge-tooltip.msai-multi-badge-tooltip-right{left:auto;right:-5px;transform:none}.msai-multi-horizontal-badges-applied .dc-usp-row{border-top:none !important}",
    );
  })();
});
